import axios from "axios";
import * as localData from "@/services/localData.js";
import Vue from "vue";
import { postData,getSSO,getData } from "@/services/api.js";
import router from '@/router';
// import {
//   toaster_success,
//   toaster_error,
//   toaster_info,
// } from "@/services/helper.js";

const state = () => ({
  status: "",
  auth_token: localData.getlocal("auth_token") || "",
  refresh_token: localData.getlocal("refresh_token") || "",
  username: localData.getlocal("username") || "",
  user_id: localData.getlocal("user_id") || "",
  is_admin: localData.getlocal("is_admin") || "",
  first_name: localData.getlocal("first_name") || "",
  last_name: localData.getlocal("last_name") || "",
  email: localData.getlocal("email") || "",
  roles: localData.getArraylocal("roles") || [],
  roles_client: localData.getArraylocal("roles_client") || [],
  client_group: localData.getArraylocal("client_group") || [],
  user_type: localData.getlocal("user_type") || "",
  users_list: []
});

const mutations = {
  auth_request(state) {
    state.status = "loading";
  },
  auth_success(state, data) {
    state.status = "success";
    state.auth_token = data.token;
    state.refresh_token = data.refreshToken;
    state.username = data.userName;
    //state.user_id = data.user_id;
    //state.is_admin = data.is_admin;
    state.first_name = data.tokenParsed.given_name;
    state.last_name = data.tokenParsed.family_name;
    state.email = data.tokenParsed.email;
    state.roles = data.realmAccess.roles;
    state.roles_client = data.resourceAccess["datamanagement-front"].roles;
    state.client_group = data.tokenParsed.groupMember;
    //state.user_type = data.user_type;
  },
  auth_error(state) {
    state.status = "error";
  },
  logout(state) {
    state.status = "";
    state.auth_token = "";
    state.refresh_token = "";
    state.username = "";
    state.user_id = "";
    state.is_admin = "";
    state.first_name = "";
    state.last_name = "";
    state.email = "";
    state.user_type = "";
    state.roles = "";
    state.roles_client = "";
    state.client_group = "";
  },
  auth_validate(state, auth_token) {
    state.status = "success";
    state.auth_token = auth_token;
  },
  auth_user_type(state, auth_token) {
    state.user_type = auth_token.user_type;
  },
  setUsersList(state, data) {
    state.users_list = data
  }
};

const actions = {
  setUserParams({ commit },user) {
    return new Promise((resolve, reject) => {
  
      localData.setlocalToken("auth_token", user.token);
      localData.setlocal("refresh_token", user.refreshToken);

      if (localStorage.username != user.userName){
        localData.setlocal("username", user.userName);
        localData.setlocal("first_name", user.tokenParsed.given_name);
        localData.setlocal("last_name", user.tokenParsed.family_name);
        localData.setlocal("email", user.tokenParsed.email);
        localData.setlocal("roles", user.realmAccess.roles);
        localData.setlocal("roles_client", user.resourceAccess["datamanagement-front"].roles);
        localData.setlocal("client_group", user.tokenParsed.groupMember);
        //toaster_success("Welcome back to LifePortSound, " + user.userName);
      }
      commit("auth_success", user);
    });
  },
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      router.push('/')
      Vue.prototype.$keycloak.logoutFn()
      commit("logout")
      localData.deleteAll()
      resolve("OK");
    });
  },
  async GetUsersList({ commit }, data) {
    let res = await getData('alerts/users-list/')
    commit('setUsersList',res.data)
  },
};
const getters = {
  isLoggedIn: (state) => !!state.auth_token,
  authStatus: (state) => state.status,
  token: (state) => state.auth_token,
  user_id: (state) => state.user_id,
  is_admin: (state) => state.is_admin,
  first_name: (state) => state.first_name,
  last_name: (state) => state.last_name,
  email: (state) => state.email,
  user_type: (state) => state.user_type,
  roles: (state) => state.roles,
  roles_client: (state) => state.roles_client,
  client_group: (state) => state.client_group,
  is_technician: (state) => {
    return state.user_type == "technician" ? true : false;
  },
  is_manager: (state) => {
    return state.user_type == "manager" ? true : false;
  },
  is_coordinator: (state) => {
    return state.user_type == "coordinator" ? true : false;
  },
  username: (state) => state.username,
  users_list: (state) => {
    var users_list = [...state.users_list]
    users_list = users_list.filter(function(user) {
      if(user.username != state.username)
        return true
    })
    return [...users_list]
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
